'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FlagsEN = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#000066",
                d: "M0 3.2h15.865v9.6H0z"
            }),
            /*#__PURE__*/ jsx("mask", {
                id: "EN_svg__mask0_3671_83",
                width: 16,
                height: 10,
                x: 0,
                y: 3,
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: 'luminance'
                },
                children: /*#__PURE__*/ jsx("path", {
                    fill: "white",
                    d: "M0 3.2h15.865v9.6H0z"
                })
            }),
            /*#__PURE__*/ jsxs("g", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                mask: "url(#EN_svg__mask0_3671_83)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fill: "white",
                        d: "M-1.6 4.274V3.2H.532l7.401 3.727L5.801 8zm9.533 4.8L.532 12.8H-1.6v-1.073L5.801 8zm0 0L10.064 8l7.402 3.727V12.8h-2.132zM10.064 8 7.933 6.927 15.334 3.2h2.132v1.073z"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "white",
                        d: "M6.344 6.4V3.2h3.178v3.2h7.944v3.2H9.522v3.2H6.344V9.6H-1.6V6.4z"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        fill: "#CC0000",
                        d: "M6.98 7.04V3.2h1.906v3.84h8.58v1.92h-8.58v3.84H6.98V8.96H-1.6V7.04zM-1.6 12.8l6.355-3.2h1.421l-6.355 3.2zm6.355-6.4L-1.6 3.2v.716L3.334 6.4zm4.935 0 6.355-3.2h1.42l-6.354 3.2zm1.42 3.2 6.356 3.2v-.715L12.53 9.6z"
                    })
                ]
            })
        ]
    })));

export { FlagsEN, FlagsEN as default };
//# sourceMappingURL=FlagsEN.js.map
